import styled from "styled-components";

export const LogoImg = styled.img`
width: 300px;
height: auto;
margin-bottom: 0.5rem;
`